import React from 'react'
import { useRouter } from 'next/router'
import styles from './BottomNav.module.scss'
import { Heading } from '~elements'
import { Dayjs } from 'dayjs'
import dayjs from 'utils/dayjs'
import ChevronRight from '/public/assets/svg/chevron_right.svg'
import ChevronLeft from '/public/assets/svg/chevron_left.svg'
import { isNextButtonDisabled, isPrevButtonDisabled } from 'components/modules/Calendar/utils'
import { DATE_FORMAT } from '~constants'
import { fireAnalyticsEvent } from '~analyticsUtils'

interface BottomNavProps {
  hideNavTitle?: boolean
  month?: Dayjs
  handleNavigation: (key: string, shouldScrollTop: boolean) => void
  activeMonthList: string[]
}

const BottomNav = ({ month, handleNavigation, activeMonthList }: BottomNavProps) => {
  const isPrevDisabled = isPrevButtonDisabled(
    month ? month.format(`${DATE_FORMAT.SHORT_MONTH}-${DATE_FORMAT.SHORT_YEAR}`) : '',
    activeMonthList
  )
  const isNextDisabled = isNextButtonDisabled(
    month ? month.format(`${DATE_FORMAT.SHORT_MONTH}-${DATE_FORMAT.SHORT_YEAR}`) : '',
    activeMonthList
  )

  // Find the index of the current month in activeMonthList
  const currentIndex = activeMonthList.findIndex(m =>
    dayjs(m, DATE_FORMAT.MONTH_YEAR_SHORT).isSame(dayjs(month, DATE_FORMAT.MONTH_YEAR_SHORT), 'month')
  )

  const prevMonth = currentIndex > 0 ? activeMonthList[currentIndex - 1] : null
  const nextMonth =
    currentIndex >= 0 && currentIndex < activeMonthList.length - 1 ? activeMonthList[currentIndex + 1] : null
  // Format the month names using dayjs
  const prevMonthName = prevMonth ? dayjs(prevMonth, DATE_FORMAT.MONTH_YEAR_SHORT).format(DATE_FORMAT.MONTH) : ''
  const nextMonthName = nextMonth ? dayjs(nextMonth, DATE_FORMAT.MONTH_YEAR_SHORT).format(DATE_FORMAT.MONTH) : ''

  const linkModule = 'calendar_bottom_nav'
  const { asPath } = useRouter()
  const analyticsClickHandler = (monthName: string) => {
    fireAnalyticsEvent(null, asPath, {
      linkModule: linkModule,
      clickTracking: `${linkModule}:${monthName}`
    })
  }

  return (
    <div className={styles['month-nav-group']}>
      <button
        className={styles['month-nav-group__nav']}
        onClick={
          isPrevDisabled
            ? undefined
            : () => {
                handleNavigation('previous', true)
                analyticsClickHandler(prevMonthName)
              }
        }
        disabled={isPrevDisabled}
      >
        <div className={styles['nav-icon-wrapper']}>
          <ChevronLeft />
        </div>
        <Heading level={3}>{prevMonthName}</Heading>
      </button>
      <button
        className={styles['month-nav-group__nav']}
        onClick={
          isNextDisabled
            ? undefined
            : () => {
                handleNavigation('next', true)
                analyticsClickHandler(nextMonthName)
              }
        }
        disabled={isNextDisabled}
      >
        <Heading level={3}>{nextMonthName}</Heading>
        <div className={styles['nav-icon-wrapper']}>
          <ChevronRight />
        </div>
      </button>
    </div>
  )
}

export default BottomNav
